import { ChevronDown } from "lucide-react";
import type { SelectHTMLAttributes } from "react";

/**
 * Native select in the Pro `.field` shell (44px, 14px radius, same border and
 * focus ring as TextField). The platform arrow is dropped and a lucide chevron
 * (same 16px / 2px stroke as the app's other icons) is centered vertically and
 * inset by the shell's 14px horizontal padding, so the caret is optically
 * balanced against the text on the left.
 */
export function JoinSelect({
  className,
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <div className={`field relative${className ? ` ${className}` : ""}`}>
      <select
        {...props}
        className="h-full min-h-[42px] w-full appearance-none bg-transparent pr-7 text-sm text-fg outline-none"
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-[14px] top-1/2 size-4 -translate-y-1/2 text-fg-muted"
        strokeWidth={2}
      />
    </div>
  );
}
